module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-6.71b1d969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-6.jpg
// module id = 1892
// module chunks = 2